import { jwtDecode } from "jwt-decode";

interface JwtToken {
  exp: number;
  scopes: string[];
  sub: string;
  okta_id: string;
}

const emptyToken: JwtToken = {
  exp: 0,
  scopes: [],
  sub: "",
  okta_id: "",
};

export const AUTH_TOKEN_LOCAL_STORAGE_KEY = "AUTH_TOKEN";

export const isExpired = (expiry: number): boolean =>
  expiry * 1000 < Date.now();

const getTokenFromUrl = () => window?.location.hash.replace("#", "");

export const getToken = (): { token: string; expiry: number } => {
  const tokenFromUrl = getTokenFromUrl().length ? getTokenFromUrl() : null;
  const token = tokenFromUrl
    ? tokenFromUrl
    : localStorage.getItem(AUTH_TOKEN_LOCAL_STORAGE_KEY) ?? "";

  return {
    token: token,
    expiry: parseJwtToken(token).exp,
  };
};

const onExpiredToken = (
  authenticated: boolean,
  setAuthenticated: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const { expiry: tokenExpiry, token } = getToken();
  const tokenExpired = isExpired(tokenExpiry);

  if ((tokenExpired && authenticated) || (!token && authenticated)) {
    setAuthenticated(false);
  } else if (token && !tokenExpired && !authenticated) {
    setAuthenticated(true);
  }
};

export const checkTokenExpiryOnInterval = (
  authenticated: boolean,
  setAuthenticated: React.Dispatch<React.SetStateAction<boolean>>
) => {
  // check whether token is expired on regular interval
  const interval = setInterval(
    () => onExpiredToken(authenticated, setAuthenticated), 10000
  );
  return () => {
    clearInterval(interval);
  };
};

export const parseJwtToken = (token = ""): JwtToken => {
  if (!token) {
    return emptyToken;
  }

  try {
    return jwtDecode<JwtToken>(token);
  } catch (error) {
    return emptyToken;
  }
};

